import { chainCommands } from 'prosemirror-commands';
import { YfmTabsSpecs } from './YfmTabsSpecs';
import { createYfmTabs } from './actions';
import { dragAutoSwitch, joinBackwardToOpenTab, removeTabWhenCursorAtTheStartOfTab, tabEnter, tabPanelArrowDown, } from './plugins';
import { tabPanelView, tabView } from './views';
export { TabsNode, tabType, tabsType, tabsListType, tabPanelType } from './YfmTabsSpecs';
const actionName = 'toYfmTabs';
export const YfmTabs = (builder) => {
    builder.use(YfmTabsSpecs, {
        tabView: () => tabView,
        tabPanelView: () => tabPanelView,
    });
    builder.addKeymap(() => ({
        Backspace: chainCommands(removeTabWhenCursorAtTheStartOfTab, joinBackwardToOpenTab),
        ArrowDown: tabPanelArrowDown,
        Enter: tabEnter,
        'Shift-Enter': tabEnter,
    }), builder.Priority.High);
    builder.addAction(actionName, () => createYfmTabs);
    builder.addPlugin(dragAutoSwitch);
};
